<div class="flex flex-col rounded-md bg-surface">
  <div
    class="flex cursor-pointer gap-2.5 px-2.5 py-2 text-sm font-semibold text-default"
    role="button"
    (click)="isActive = !isActive"
  >
    <sb-icon
      name="chevron-right"
      size="xxs"
      class="self-center text-support transition-transform ease-in-out"
      [ngClass]="{ 'rotate-90': isActive }"
    >
    </sb-icon>
    <span class="flex-1">{{ partial.label }} </span>
    <span>{{ partial.value }}</span>
  </div>
  <div
    class="grid transition-collapse duration-300 ease-in-out"
    [ngClass]="{ 'grid-rows-collapse': !isActive, 'grid-rows-collapse-expanded pb-2': isActive }"
  >
    <div class="flex flex-col overflow-hidden px-1.5">
      <div
        class="flex flex-col rounded-md bg-surface-page p-2 text-sm font-medium text-support transition-opacity duration-300 ease-in-out"
        [ngClass]="{ 'opacity-30': !isActive, 'opacity-100': isActive }"
      >
        @if (partial.items.length) {
          @for (item of partial.items; track $index) {
            <time-off-partial-balance-item [item]="item" [employee]="employee()"> </time-off-partial-balance-item>
          }
        } @else {
          <div class="flex items-center justify-center p-3">
            <span class="text-subtle">{{ 'No corrections' | translate }}</span>
          </div>
        }
        <div class="my-2">
          <hr sbDivider />
        </div>
        <div class="flex justify-between font-bold text-default">
          <span>{{ 'Total' | translate }}</span>
          <span>{{ partial.value }}</span>
        </div>
      </div>

      @if (partial.itemsAreCorrections) {
        @if (canAdjustTimeOffBalances()) {
          <button
            [routerLink]="[
              '',
              { outlets: { modal: ['time-off-correction', 'time_off_balance', employee().id, partial.balanceId] } },
            ]"
            sb-button
            color="primary"
            class="mt-2"
          >
            {{ 'Make correction' | translate }}
          </button>
        }
      }
    </div>
  </div>
</div>
